import httpClient from '../../utils/httpClient';
import type {Template} from '../../types/package';

interface TemplateSuggestion {
    template: Template & {recipients?: any[]; documents?: any[]};
    similarity: number;
}

interface TemplateSuggestionsResponse {
    packageName: string;
    suggestions: TemplateSuggestion[];
    count: number;
    message?: string;
}

interface FlushTemplateCacheResponse {
    success: boolean;
    message?: string;
}

/**
 * Fetches template suggestions from the AI endpoint
 * @param searchQuery The search query string
 * @param includeShared Whether to include shared templates
 * @returns Promise resolving to template suggestions or error
 */
export async function fetchTemplateSuggestions(
    searchQuery: string,
    includeShared = true
): Promise<TemplateSuggestionsResponse> {
    const response = await httpClient.get('/proxyAi/template-suggestions', {
        params: {
            packageName: searchQuery,
            includeShared
        }
    });

    return response.data;
}

/**
 * Flushes the template cache for a specific template or all templates
 * @param templateId Optional template ID to flush cache for specific template
 * @returns Promise resolving to flush result or error
 */
export async function flushTemplateCache(
    templateId?: string
): Promise<FlushTemplateCacheResponse> {
    const params = templateId ? {templateId} : {};
    const response = await httpClient.get('/proxyAi/flush-template-cache', {
        params
    });

    return response.data;
}

export type {
    TemplateSuggestion,
    TemplateSuggestionsResponse,
    FlushTemplateCacheResponse
};
